import { FC } from 'react';

import s from '../Modal/Modal.module.scss';

const DialogTitle: FC<React.PropsWithChildren<React.PropsWithChildren<{ title: string }>>> = ({ title }) => {
  return <div className={s.header__title}>{title}</div>;
};

export default DialogTitle;
